import { POSTGRES_CODES } from "@lib/errors/postgresCodes";
import type { FeatureErrorMapper } from "@lib/errors/types";

const NO_INVENTORY_MARKER = "No inventory found for product ID";

export const orderErrorMapper: FeatureErrorMapper = (_action, err) => {
  if (err.message.includes(NO_INVENTORY_MARKER)) {
    return "No inventory found for this product.";
  }

  if (err.code === POSTGRES_CODES.UNIQUE_VIOLATION) {
    if (
      err.constraint === "unique_order_number_per_org" ||
      err.message.includes("unique_order_number_per_org")
    ) {
      return "Order number is already in use.";
    }
    return "An order with these details already exists.";
  }

  return null;
};
